import $ from "jquery";
import { util } from "./util.js";
import { commTools } from "./commTools.js";
import "../../libs/uploadifive/jquery.uploadifive.js";

let API = util.api([
  "IMPROPERCREATEORDER", // 创建保密订单
  "SINGLECREATEORDER", // 创建普通订单
  "UPLOAD", // 上传
]);

let temp = {
  creatOrder: `<div class="create_order" id="creatOrder">
					<i class="close" onclick="$.modal('close')"></i>
				    <form id="order-form">
				        <p class="title">新建订单</p>
				        <div class="section1">
				            <span class="state upload-tip">未上传</span>
				            <span style="display:none">
				            	<span id="order-upload-obj"></span>
				            </span>
				            <input name="auditionIds" check="require" style="display:none"/>
				            <button type="button" class="upload" id="order-upload-btn">上传稿件</button>
				            <span style="font-size: 12px; color: #9b9b9b;">如需帮助，</span>
				            <div class="contact kf_btn right">
				                <span>联系客服</span>
				                <div class="kf_list_wrap">
				                    <div class="kf_list">
				                        <div class="arrow_top">
				                            <div class="arrow_inner"></div>
				                        </div>
				                        <ul>
											
				                        </ul>
				                    </div>
				                </div>
				            </div>
										<span class="title__qq">QQ:1123662664</span>
				             <p class="remind">保密订单无需上传稿件,请选择<span>保密订单</span></p>
				        </div>
				        <div class="section2">
				            <p class="label">请输入您的稿件名称</p> 
                            <span class="error" data-error="请填写稿件名称"></span>
				            <input type="text" name="contributionName">
				        </div>
				        <div class="section3">
				            <p class="label">订单需求</p> <span class="error" data-error="请填写订单需求"></span>
				            <textarea name="requirementInfo" placeholder="请简要描述您的需求信息"></textarea>
				        </div>
				        <div class="section4">
				            <span>紧急状态：</span>
				            <select name="pressingStatus">
				                <option value="1">低</option>
				                <option value="2">中</option>
				                <option value="3">高</option>
				            </select>
				        </div>
				        <div class="section5">
				            <ul>
				                <li><button type="button"  class="order-normal-btn">创建订单</button></li>
				                <li><button type="button"  class="order-special-btn">创建保密订单</button></li>
				                <li><button type="button"  class="order-back" onclick="$.modal('close')">返回订单</button></li>
				            </ul>
				        </div>
				    </form>
				</div>`,
};

let check = {
  auditionIds(dom) {
    dom = dom || $("#order-form").find("[name=auditionIds]");
    // 保密订单不需要
    if (!dom.val()) {
      $(".upload-tip").css("color", "red");
      return false;
    } else {
      return true;
    }
  },
  contributionName(dom) {
    dom = dom || $("#order-form").find("[name=contributionName]");
    var err = dom.siblings("[data-error]");
    if (!dom.val()) {
      err.show().text(err.data("error"));
      err.siblings("input").addClass("error");
      return false;
    } else {
      dom.siblings("[data-error]").hide();
      err.siblings("input").removeClass("error");
      return true;
    }
  },
  requirementInfo(dom) {
    dom = dom || $("#order-form").find("[name=requirementInfo]");
    var err = dom.siblings("[data-error]");

    if (!dom.val()) {
      err.show().text(err.data("error"));
      err.siblings("textarea").addClass("error");
      return false;
    } else {
      err.siblings("textarea").removeClass("error");
      return true;
    }
  },
  pressingStatus(dom) {
    dom = dom || $("#order-form").find("[name=pressingStatus]");
    var err = dom.siblings("[data-error]");
    if (!dom.val()) {
      return false;
    } else {
      return true;
    }
  },
};

let fn = {
  _creatNormal(callback) {
    if (
      check.auditionIds() &&
      check.contributionName() &&
      check.requirementInfo() &&
      check.pressingStatus()
    ) {
      // 获取表单
      let param = {};
      $("#order-form")
        .serializeArray()
        .forEach(function (d, i) {
          param[d.name] = d.value;
        });
      util.kAjax(
        API.SINGLECREATEORDER,
        param,
        (json) => {
          $.modal("close");
          util.confirm.success("创建订单成功！");
          callback();
        },
        (err) => {
          $.modal("close");
          util.confirm.error(res.message);
        }
      );
    }
  },
  _creatSpecial(callback) {
    if (
      check.contributionName() &&
      check.requirementInfo() &&
      check.pressingStatus()
    ) {
      // 获取表单
      let param = {};
      $("#order-form")
        .serializeArray()
        .forEach(function (d, i) {
          param[d.name] = d.value;
        });
      util.kAjax(
        API.IMPROPERCREATEORDER,
        param,
        (json) => {
          $.modal("close");
          util.confirm.success("创建订单成功！");
          callback();
        },
        (err) => {
          $.modal("close");
          util.confirm.error(res.message);
        }
      );
    }
  },
};

let action = {
  /**
   * 创建订单窗口
   */
  creatOrder(callback) {
    // util.getUserInfo(function(){
    $.modal("pop", temp.creatOrder);
    let wrap = $("#creatOrder"),
      upload = wrap.find("#order-upload-btn"),
      upload_obj = wrap.find("#order-upload-obj"),
      uploadTip = wrap.find(".upload-tip"),
      auditionIds = wrap.find("[name=auditionIds]"),
      contributionName = wrap.find("[name=contributionName]"),
      requirementInfo = wrap.find("[name=requirementInfo]"),
      pressingStatus = wrap.find("[name=pressingStatus]"),
      normal = wrap.find(".order-normal-btn"),
      special = wrap.find(".order-special-btn");
    wrap.css("top", "15%");
    // 上传控件
    commTools.initUpload(upload_obj, {
      buttonText: "上传稿件",
      fileType: ".txt,.doc,.docx,.ppt,.pptx",
      uploadScript: API.UPLOAD + ";jsessionid=" + window.USERINFO.sessionId,
      onUploadComplete: function (file, data) {
        var data = eval("(" + data + ")");
        if (data.status == 4) {
          let auth = require("./auth.js").auth;
          auth.pop_login();
        }
        // 地址
        auditionIds.val(data.data);
        uploadTip.text("已上传").css("color", "#2dbfee");
        // contributionName
        contributionName.val(file.name);
        check.contributionName();
      },
    });
    // 触发上传
    upload.click(() => {
      $("#uploadifive-order-upload-obj").find("input:last").click();
    });
    let lock = false;
    // 创建订单
    normal.click(function () {
      if (!lock) {
        fn._creatNormal(callback);
        lock = true;
        setTimeout(() => {
          lock = false;
        }, 1000);
      }
    });
    special.click(function () {
      if (!lock) {
        fn._creatSpecial(callback);
        lock = true;
        setTimeout(() => {
          lock = false;
        }, 1000);
      }
    });
  },
};

/**
 * 公共获得焦点事件
 */
$("body").on("focus", "form input, form textarea", function () {
  $(this).siblings("[data-error]").hide();
});
/**
 * 公共失去焦点事件
 */
$("body").on("blur", "form input, form textarea", function () {
  let $this = $(this);
  let name = $this.attr("name");
  check[name] && check[name]($this);
});

let service = action;
window.service = action;
export { service };



// WEBPACK FOOTER //
// ./src/service/service.js